export default __webpack_public_path__ + "horse-racing.icon-5f11b95abfe80c1ae953cc1bdbe7321a.png";